import * as Sentry from '@sentry/vue';
import { getAppConfig } from './appConfig';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export const initSentry = async (app: App, router: Router) => {
  const appConfig = getAppConfig();
  const sentryConfig = appConfig.sentry;
  if (sentryConfig.enabled) {
    Sentry.init({
      app,
      logErrors: true, // Also log to console
      trackComponents: true,
      dsn: sentryConfig.dsn,
      integrations: [
        Sentry.replayIntegration({
          networkDetailAllowUrls: [
            window.location.origin,
            'https://letapps.letpension.dk',
            'https://letapps.letpension.dk/api/brugerauthorization/check',
            getAppConfig().apiRoot,
          ],
          networkRequestHeaders: ['Cache-Control'],
          networkResponseHeaders: ['Referrer-Policy'],
        }),
        Sentry.browserTracingIntegration({
          router,
          tracingOrigins: [window.location.origin, getAppConfig().apiRoot],
        }),
      ],
      // Session Replay
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: sentryConfig.tracesSampleRate,

      release: appConfig.buildNumber,
      environment: appConfig.env,
    });
    console.log('Sentry initialized');
  }
};
